import React from 'react';
import BackButton from '../BackButton';
import styled from 'styled-components';
import {
  FullWidthImage,
  ArticleImage,
  ImageOverlay,
  ImageTitle,
} from './styles/ArticlesStyle';

interface ArticleWideProps {
  title: string;
  imageUrl: string;
  backButtonLink: string;
}

const ImageContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;

const ArticleWide: React.FC<ArticleWideProps> = ({
  title,
  imageUrl,
  backButtonLink,
}) => {
  return (
    <FullWidthImage>
      {/* <BackButton to={backButtonLink} /> */}
      <ImageContainer>
        <ArticleImage src={imageUrl} alt={title} />
        <ImageOverlay />
        <ImageTitle>{title}</ImageTitle>
      </ImageContainer>
    </FullWidthImage>
  );
};

export default ArticleWide;
